import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationES from "./locales/es.json";
import translationEN from "./locales/en.json";

const resources = {
  es: { translation: translationES },
  en: { translation: translationEN },
};

const customLanguageDetector = {
  type: "languageDetector",
  async: true,
  detect: (callback) => {
    let detected = localStorage.getItem("i18nextLng");
    if (detected) {
      detected = detected.split("-")[0];
    } else {
      detected = "es";
    }
    callback(detected);
  },
  init: () => {},
  cacheUserLanguage: (lng) => {
    localStorage.setItem("i18nextLng", lng);
  },
};

i18n
  .use(customLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    interpolation: { escapeValue: false },
    supportedLngs: ["es", "en"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
  });

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = (lng || "es").slice(0, 2);
  }
});

if (typeof document !== "undefined") {
  document.documentElement.lang = (i18n.language || "es").slice(0, 2);
}

export default i18n;
